import styled, { css } from 'styled-components'
import { white, red, black } from '../../styles/colors'
import { minmedia } from '../../styles/media-queries'

export const Cta = styled.div`
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 1.5rem;
  height: 250px;
  width: 100%;
  ${minmedia.large`
    margin-bottom: 0;
    padding: 0 3rem;
    height: 350px;
  `};
  margin-top: ${props => (props.mt ? '1.5rem' : '0')};
  ${props =>
    props.size === 'small' &&
    css`
      height: 220px;
      ${minmedia.large`
        height: 220px;
      `};
      ${Title} {
        font-size: 24px;
      }
      ${Subtitle} {
        font-size: 18px;
      }
      ${Button} {
        font-size: 18px;
      }
    `};
`

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  margin-top: 0;
  position: absolute;
  background-repeat: no-repeat;
  left: 0;
  top: 0;
`

export const ContentContainer = styled.div`
  text-align: center;
  width: 100%;
  position: relative;
  z-index: 3;
`

export const Title = styled.div`
  color: ${white};
  font-size: 24px;
  margin: 0 auto;
  margin-bottom: 0.5rem;
  font-weight: 700;
  max-width: 400px;
  ${minmedia.medium`
    font-size: 35px;
  `};
`

export const Subtitle = styled.div`
  font-size: 22px;
  color: ${white};
  ${minmedia.medium`
    font-size: 24px;
  `};
`

export const Button = styled.a`
  transition: all 0.5s;
  text-decoration: none;
  display: inline-block;
  color: ${white};
  background: ${red};
  font-size: 18px;
  padding: 0.75rem 2rem;
  border-radius: 0.25rem;
  margin-top: 1.5rem;
  ${minmedia.medium`
    font-size: 22px;
  `};
  &:hover {
    background: ${black};
  }
`



// WEBPACK FOOTER //
// ./src/components/SimpleCTA/styles.js